import React, {
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
  useMemo,
} from "react";

import axios from "axios";
import locale from "antd/es/date-picker/locale/pt_BR";

import moment from "moment";
import api from "../../services/api";
import paraguaiDistrict from "../../services/allParaguayDistrict";
import { onlyNumbers } from "../../services/onlyNumber";
import { verifyPermission, getTokenInfo } from "../../services/auth";
import { formatRuc } from "../../services/rucFormater";

import MaskedInput from "antd-mask-input";
import Companies from "../../components/Companies";

import VerificationPhone from "../../components/VerificationPhone";
import { cpf } from "cpf-cnpj-validator";

import Brasil from "../../assets/image/brasil.webp";
import Paraguai from "../../assets/image/paraguai.webp";

import { User as UserModel } from "../../models/entities/user";

import {
  atuationArea,
  genderOptions,
  maritalStatus,
  scholarityOptions,
} from "../../models/franchiseeInfos";

import {
  Checkbox,
  Divider,
  Modal,
  notification,
  Input,
  Select,
  Tabs,
} from "antd";

import {
  Form,
  FormItem,
  Row,
  Col,
  Option,
  BtnsAddUser,
  ButtonCancel,
  ButtonSave,
  BtnsModalUser,
  Exclamation,
  ModalConfirmEdit,
  ContentButton,
  ButtonCountry,
  Country,
  DatePicker,
  DrawerNewUser,
  HeaderTitle,
} from "./styles";
import { UserLevel } from "../../models/enums/UserLevel";

interface IProps {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  visibleEditUser: boolean;
  setVisibleEditUser: Dispatch<SetStateAction<boolean>>;
  setUser: Dispatch<SetStateAction<UserModel | null>>;
  setShouldSearch: Dispatch<SetStateAction<boolean>>;
  user?: UserModel | null;
  users?: UserModel[];
  profiles?: UserModel[];
}

interface IViaCep {
  bairro: string | null;
  cep: string | null;
  complemento: string | null;
  ddd?: string | null;
  gia?: string | null;
  ibge: string | null;
  localidade: string | null;
  logradouro: string | null;
  siafi?: string | null;
  uf: string | null;
}

const UserForm: React.FC<IProps> = ({
  visible,
  setVisible,
  visibleEditUser,
  setVisibleEditUser,
  user,
  setUser,
  setShouldSearch,
  profiles,
}) => {
  const [companies, setCompanies] = useState<number[]>([]);
  const [isProfile, setIsProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleConfirmEdit, setVisibleConfirmEdit] = useState(false);
  const [profileType, setProfileType] = useState<number | undefined>(undefined);
  const [selectedScholarity, setSelectedScholarity] = useState<
    number | undefined
  >();
  const [isMarried, setIsMarried] = useState<number | undefined>();
  const [checked, setChecked] = useState(false);
  const [viaCepData, setViaCepData] = useState<IViaCep>();
  const [isAnotherArea, setIsAnotherArea] = useState<string | undefined>();
  const [selectCountryInput, setSelecteCountryInput] = useState("BR");

  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [pendingUserData, setPendingUserData] = useState<any>(null);

  const canEditFields = () => {
    const userLevel = getTokenInfo()?.level;
    return (
      userLevel !== undefined &&
      userLevel !== null &&
      userLevel <= UserLevel.ADMIN
    );
  };

  useEffect(() => {
    const setUserInputs = async () => {
      delete user?.password;

      setIsMarried(isProfile ? user?.marital_status : undefined);
      setSelectedScholarity(user?.scholarity);
      setIsAnotherArea(isProfile ? user?.atuation : undefined);

      await form.setFieldsValue({
        ...user,
        country_code: user?.country_code
          ? user.country_code
          : user?.cpf
          ? "+55"
          : "+595",
        validated_email: user?.email,
        profile_permission: user?.profile_permission?.split(".")[1],
        birthday: user?.birthday ? moment(user?.birthday) : null,
      });

      if (user) {
        setSelecteCountryInput(user.cpf ? "BR" : "PY");
      }

      if (user?.is_profile) {
        setIsProfile(true);
      }
    };

    if (user) {
      setUserInputs();
    } else {
      resetFormFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, form, isProfile, visible]);

  const resetFormFields = async () => {
    await form.resetFields();
    setSelecteCountryInput("BR");
    await form.setFieldsValue({ country_code: "+55" });
  };

  const clearFields = () => {
    setUser(null);
    setIsMarried(undefined);
    setSelectedScholarity(undefined);
    form.resetFields();
  };

  const closeModals = () => {
    setVisible(false);
    setVisibleEditUser(false);
    setVisibleConfirmEdit(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      let payload = form.getFieldsValue();
      if (payload.validated_email !== payload.email) {
        notification.warning({
          message: "E-mails inválidos",
          description: "Os e-mails devem ser iguais",
          duration: 3,
        });
        return;
      }

      if (
        payload.atuation === "Outro (especificar)" &&
        payload.other_atuation
      ) {
        payload.atuation = payload.other_atuation;
        delete payload.other_atuation;
      }

      delete payload.validated_email;
      payload.name = payload.name?.toLowerCase()?.trim();
      payload.last_name = payload.last_name?.toLowerCase()?.trim();
      payload.full_name = payload.name + " " + payload.last_name;
      payload.email = payload.email?.toLowerCase()?.trim();
      payload.username = payload.email;
      if (payload.birthday) {
        payload.birthday = moment(payload.birthday).set({
          hour: 12,
          minute: 0,
          second: 0,
        });
      }

      if (payload.cpf) {
        payload.cpf = onlyNumbers(payload.cpf)?.toString();
      }
      if (payload.phone) {
        payload.phone = onlyNumbers(payload.phone)?.toString();
      }
      if (!payload.password) {
        delete payload.password;
      }

      if (selectCountryInput === "PY") {
        payload.ruc = payload.ruc?.toString();
        delete payload.cpf;
      }

      const method = user?.id ? "put" : "post";
      if (method === "post" && !companies.length) {
        notification.warning({
          message: "Nenhuma empresa selecionada",
          description: `Selecione pelo menos uma empresa para o usuário`,
          duration: 3,
        });
        return;
      }

      if (
        user?.id &&
        canEditFields() &&
        payload.phone &&
        !payload.ruc &&
        payload.phone !==
          (user?.phone ? onlyNumbers(user.phone)?.toString() : null)
      ) {
        setPendingUserData({ ...payload, companies });
        setVisibleConfirmEdit(false);
        setCurrentStep(1);
        setLoading(false);
        return;
      }

      if (user?.id) {
        await api.put(`/user/${user.id}`, { ...payload, companies });
      } else {
        if (!companies.length) {
          notification.warning({
            message: "Nenhuma empresa selecionada",
            description: `Selecione pelo menos uma empresa para o usuário`,
            duration: 3,
          });
          return;
        }
        await api.post("/user/create-user-partial", { ...payload, companies });
      }

      notification.success({
        message: user?.id
          ? "Usuário editado com sucesso"
          : "Usuário cadastrado com sucesso",
        duration: 3,
      });

      if (!user?.id) {
        Modal.info({
          title: "Verificação de e-mail",
          content:
            "Um PIN de verificação foi enviado para o e-mail cadastrado. Oriente o usuário a fazer login na plataforma.",
          okText: "OK",
          centered: true,
          className: "verification-modal",
          okButtonProps: {
            style: {
              backgroundColor: "#ff6b35",
              borderColor: "#ff6b35",
              color: "white",
              borderRadius: "4px",
              fontWeight: "bold",
            },
          },
        });
      }

      setShouldSearch(true);
      clearFields();
      setCompanies([]);
      closeModals();
    } catch (err: any) {
      let errorMessages: any[] = [];
      if (err && err.errorFields && Array.isArray(err.errorFields)) {
        err.errorFields.forEach((fieldError) => {
          if (
            fieldError &&
            fieldError.errors &&
            Array.isArray(fieldError.errors)
          ) {
            errorMessages = errorMessages.concat(fieldError.errors);
          }
        });
      } else {
        const errorMessageFromResponse = err?.response?.data?.message;
        if (errorMessageFromResponse) {
          errorMessages.push(errorMessageFromResponse);
        }
      }
      const errorMessage =
        errorMessages.length > 0
          ? errorMessages.join(", ")
          : "Um erro interno ocorreu";

      notification.warning({
        message: "Ops! Erro ao cadastrar usuário",
        description: errorMessage,
        duration: 5,
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const completeUpdate = async () => {
    if (!pendingUserData || !user?.id) return;

    try {
      setLoading(true);

      pendingUserData.pin_phone = null;

      await api.put(
        `/user/${user.id}`,
        JSON.parse(JSON.stringify(pendingUserData))
      );

      notification.success({
        message: "Usuário editado com sucesso",
        duration: 3,
      });

      setShouldSearch(true);
      clearFields();
      setCompanies([]);
      closeModals();
    } catch (err: any) {
      const errorMessage =
        err?.response?.data?.message || "Um erro interno ocorreu";

      notification.warning({
        message: "Ops! Erro ao editar usuário",
        description: errorMessage,
        duration: 5,
      });
    } finally {
      setLoading(false);
      setCurrentStep(0);
      setPendingUserData(null);
    }
  };

  const saveNewUser = async () => {
    if (companies.length) {
      if (!user?.id) {
        onFinish();
      } else {
        setVisibleConfirmEdit(true);
      }
    } else {
      notification.warning({
        message: "Nenhuma empresa selecionada",
        duration: 3,
      });
    }
  };

  const onCancel = () => {
    Modal.confirm({
      title: "Deseja realmente cancelar?",
      content: "As informações preenchidas serão descartadas.",
      okText: "Sim",
      centered: true,
      okType: "primary",
      cancelText: "Não",
      width: 500,
      async onOk() {
        clearFields();
        setVisible(false);
        setVisibleEditUser(false);
      },
    });
  };

  const handleChangeCep = async (cep) => {
    const _cep = onlyNumbers(cep.target.value)?.toString();
    if (_cep?.length === 8) {
      const { data } = await axios({
        url: `https://viacep.com.br/ws/${_cep}/json/`,
        method: "GET",
      });
      setViaCepData(data);
      form.setFieldsValue({
        state: data?.uf || "",
        city: data?.localidade || "",
        district: data?.bairro || "",
        address: data?.logradouro || "",
        complement: data?.complemento !== "" ? data?.complemento : "Não possui",
      });
    }
  };

  const selectCountry = (country: string) => {
    if (country === "BR") {
      setSelecteCountryInput("BR");
      form.setFieldsValue({ country_code: "+55" });
    } else {
      setSelecteCountryInput("PY");
      form.setFieldsValue({ country_code: "+595" });
    }
  };

  return (
    <>
      <DrawerNewUser
        title={
          <HeaderTitle>
            {user?.id ? "Editar usuário" : "Novo usuário"}

            <ContentButton>
              <ButtonCountry
                selected={selectCountryInput === "BR"}
                disabled={user?.ruc ? true : false}
                onClick={() => selectCountry("BR")}
              >
                {useMemo(
                  () => (
                    <Country src={Brasil}></Country>
                  ),
                  []
                )}{" "}
                🇧🇷
              </ButtonCountry>
              <ButtonCountry
                selected={selectCountryInput === "PY"}
                disabled={user?.cpf ? true : false}
                onClick={() => selectCountry("PY")}
              >
                {useMemo(
                  () => (
                    <Country src={Paraguai}></Country>
                  ),
                  []
                )}{" "}
                🇵🇾
              </ButtonCountry>
            </ContentButton>
          </HeaderTitle>
        }
        destroyOnClose={true}
        width={"50%"}
        visible={visible || visibleEditUser}
        closable={false}
        placement="right"
        onClose={() => onCancel()}
        footer={
          currentStep === 0 ? (
            <BtnsAddUser>
              <ButtonCancel
                onClick={() => {
                  onCancel();
                }}
              >
                {user?.id ? "Cancelar Edição" : "Cancelar Cadastro"}
              </ButtonCancel>
              <ButtonSave
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={() => {
                  saveNewUser();
                }}
              >
                {user?.id ? "Confirmar Edição" : "Confirmar Cadastro"}
              </ButtonSave>
            </BtnsAddUser>
          ) : null
        }
      >
        {currentStep === 0 ? (
          <Form
            layout="vertical"
            form={form}
            autoComplete="new-form"
            onFinish={() => {
              onFinish();
            }}
          >
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Informações do usuário" key="1">
                <Divider orientation="left">Informações do usuário</Divider>

                <Row>
                  <Row gutter={12}>
                    <Col sm={8} xs={24}>
                      <FormItem
                        label="Nome"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "Nome é obrigatório",
                          },
                        ]}
                      >
                        <Input
                          maxLength={50}
                          name="name"
                          placeholder="Digite o nome"
                        />
                      </FormItem>
                    </Col>

                    <Col sm={8} xs={24}>
                      <FormItem
                        label="Sobrenome"
                        name="last_name"
                        rules={[
                          {
                            required: isProfile ? false : true,
                            message: "Sobrenome é obrigatório",
                          },
                        ]}
                      >
                        <Input
                          name="last_name"
                          placeholder="Digite o sobrenome"
                          type="string"
                          maxLength={50}
                        />
                      </FormItem>
                    </Col>
                    <Col sm={8} xs={24}>
                      {selectCountryInput === "BR" ? (
                        <FormItem
                          label="CPF"
                          name="cpf"
                          rules={[
                            {
                              required: true,
                              message: "CPF é obrigatório",
                            },
                            {
                              validator: (_, value) => {
                                if (!value) {
                                  return Promise.resolve();
                                }
                                const cpfCnpj = value.replace(/[^\d]+/g, "");
                                if (cpfCnpj.length === 11) {
                                  if (cpf.isValid(cpfCnpj)) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error("CPF inválido")
                                  );
                                }
                              },
                            },
                          ]}
                        >
                          <MaskedInput
                            disabled={user?.id ? true : false}
                            name="cpf"
                            mask="111.111.111-11"
                            placeholder="999.999.999-99"
                          />
                        </FormItem>
                      ) : (
                        <FormItem
                          label="RUC"
                          name="ruc"
                          rules={[
                            {
                              required: true,
                              message: "RUC é obrigatório",
                            },
                          ]}
                        >
                          <Input
                            name="ruc"
                            placeholder="Digite o RUC"
                            maxLength={10}
                            onChange={(e) => {
                              const formatted = formatRuc(e.target.value);
                              form.setFieldsValue({ ruc: formatted });
                            }}
                          />
                        </FormItem>
                      )}
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Email"
                        name="email"
                        rules={[
                          {
                            required: isProfile ? false : true,
                            message: "Email é obrigatório",
                          },
                          {
                            type: "email",
                            message: "Entre com um e-mail válido",
                          },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();

                              if (
                                value.includes("@tba") ||
                                value.includes("@teste")
                              ) {
                                return Promise.reject(
                                  new Error(
                                    "Emails com @tba ou @teste não são permitidos"
                                  )
                                );
                              }
                              const validatedEmail =
                                form.getFieldValue("validated_email");
                              if (validatedEmail && value !== validatedEmail) {
                                return Promise.reject(
                                  new Error("Os e-mails devem ser iguais")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          disabled={user?.id ? true : false}
                          name="email"
                          type="email"
                          placeholder="Digite o e-mail"
                          autoComplete="new-email"
                          maxLength={100}
                        />
                      </FormItem>
                    </Col>

                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Confirme o e-mail"
                        name="validated_email"
                        rules={[
                          {
                            required: isProfile ? false : true,
                            message: "Email é obrigatório",
                          },
                          {
                            type: "email",
                            message: "Entre com um e-mail válido",
                          },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();

                              if (
                                value.includes("@tba") ||
                                value.includes("@teste")
                              ) {
                                return Promise.reject(
                                  new Error(
                                    "Emails com @tba ou @teste não são permitidos"
                                  )
                                );
                              }

                              const email = form.getFieldValue("email");
                              if (email && value !== email) {
                                return Promise.reject(
                                  new Error("Os e-mails devem ser iguais")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          disabled={user?.id ? true : false}
                          type="email"
                          name="validated_email"
                          placeholder="Confirme o e-mail"
                          autoComplete="new-email"
                        />
                      </FormItem>
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Tipo de Conta"
                        name="level"
                        rules={[
                          {
                            required: isProfile ? false : true,
                            message: "Tipo de conta é obrigatório",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Escolha a opção"
                          disabled={!canEditFields() && user?.id !== undefined}
                        >
                          {getTokenInfo()?.level === 1 && (
                            <Option value={1}>Master</Option>
                          )}
                          {verifyPermission("user.create_level_full") && (
                            <Option value={2}>Geral</Option>
                          )}
                          {(verifyPermission("user.create_level_full") ||
                            verifyPermission("user.create_level_admin")) && (
                            <Option value={3}>Administrador</Option>
                          )}
                          {(verifyPermission("user.create_level_admin") ||
                            verifyPermission("user.create_level_owner")) && (
                            <Option value={4}>Proprietário</Option>
                          )}
                          {(verifyPermission("user.create_level_owner") ||
                            verifyPermission("user.create_level_user")) && (
                            <Option value={5}>Usuário básico</Option>
                          )}
                        </Select>
                      </FormItem>{" "}
                    </Col>

                    <Col sm={12} xs={24}>
                      <FormItem
                        label="Perfil"
                        name="profile"
                        rules={[
                          {
                            required: true,
                            message: "Perfil é obrigatório",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Escolha a opção"
                          value={profileType}
                          onChange={(value) =>
                            setProfileType(value as number | undefined)
                          }
                        >
                          {profiles?.map((_profiles) => (
                            <Option value={_profiles?.id} key={_profiles?.id}>
                              {_profiles?.name}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                  {user?.id && (
                    <>
                      <Row gutter={12}>
                        <Col sm={12} xs={24}>
                          <Form.Item label="Gênero" name="gender">
                            <Select
                              placeholder="Selecione o gênero"
                              showSearch
                              disabled={!canEditFields()}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {genderOptions.map((option) => (
                                <Select.Option
                                  value={option.value}
                                  key={option.value}
                                >
                                  {option.description}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col sm={12} xs={24}>
                          <Form.Item
                            label="Data de nascimento"
                            name="birthday"
                            style={{ paddingBottom: "5px" }}
                          >
                            <DatePicker
                              placeholder="Data de nascimento"
                              name="birthday"
                              format="DD/MM/YYYY"
                              locale={locale}
                              inputReadOnly={true}
                              allowClear={true}
                              disabled={!canEditFields()}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={12}>
                        <Col sm={12} xs={24}>
                          <Form.Item label="Atuação" name="atuation">
                            <Select
                              placeholder="Selecione a área de atuação"
                              showSearch
                              disabled={!canEditFields()}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(value) =>
                                setIsAnotherArea(value as string)
                              }
                            >
                              {atuationArea.map((option) => (
                                <Select.Option
                                  value={option.description}
                                  key={option.value}
                                >
                                  {option.description}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>

                          {isAnotherArea === "Outro (especificar)" && (
                            <FormItem
                              label="Outra área de atuação"
                              name="other_atuation"
                              rules={[
                                {
                                  required: true,
                                  message: "A atuação é obrigatória",
                                },
                              ]}
                            >
                              <Input
                                maxLength={50}
                                name="other_atuation"
                                placeholder="Digite a área de atuação"
                                disabled={!canEditFields()}
                              />
                            </FormItem>
                          )}
                        </Col>

                        <Col sm={12} xs={24}>
                          <Form.Item label="Estado civil" name="marital_status">
                            <Select
                              placeholder="Selecione o estado civil"
                              showSearch
                              disabled={!canEditFields()}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(value) => setIsMarried(value as any)}
                            >
                              {maritalStatus.map((option) => (
                                <Select.Option
                                  value={option.value}
                                  key={option.value}
                                >
                                  {option.description}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        {isMarried === 0 && (
                          <Col sm={12} xs={24}>
                            <Form.Item
                              label="Cônjuge irá atuar no negócio?"
                              name="marital_status"
                              rules={[
                                {
                                  required: isMarried === 0 ? true : false,
                                  message: "O campo é obrigatório",
                                },
                              ]}
                            >
                              <Checkbox
                                checked={checked}
                                onChange={() => setChecked(true)}
                                name="is_married"
                                disabled={!canEditFields()}
                              >
                                Sim, irá atuar
                              </Checkbox>
                              <Checkbox
                                checked={!checked}
                                onChange={() => setChecked(false)}
                                name="is_married"
                                disabled={!canEditFields()}
                              >
                                Não
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      <Row gutter={12}>
                        <Col sm={12} xs={24}>
                          <Form.Item
                            label="Grau de escolaridade"
                            name="scholarity"
                          >
                            <Select
                              placeholder="Selecione o grau de escolaridade"
                              showSearch
                              disabled={!canEditFields()}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(value) =>
                                setSelectedScholarity(value as any)
                              }
                            >
                              {scholarityOptions.map((option) => (
                                <Select.Option
                                  value={option.value}
                                  key={option.value}
                                >
                                  {option.description}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col sm={12} xs={24}>
                          {selectedScholarity && selectedScholarity >= 6 ? (
                            <Form.Item label="Cursos/Graduações" name="courses">
                              <Input
                                name="courses"
                                disabled={!canEditFields()}
                              />
                            </Form.Item>
                          ) : null}
                        </Col>
                      </Row>
                    </>
                  )}
                </Row>
                <Divider orientation="left">Empresas</Divider>

                <Row>
                  <Row>
                    <Col sm={24} xs={24}>
                      <Companies
                        userId={user?.id}
                        handleChange={(companyIds) => setCompanies(companyIds)}
                      />
                    </Col>
                  </Row>
                </Row>
              </Tabs.TabPane>
              {user?.id && (
                <Tabs.TabPane tab="Dados de contato e localização" key="2">
                  <Divider orientation="left">Informações de contato</Divider>
                  <Row gutter={12}>
                    <Col sm={3} xs={4}>
                      <FormItem label="Código" name="country_code">
                        <Select disabled={!canEditFields()}>
                          <Option key={1} value={"+55"}>
                            +55
                          </Option>
                          <Option key={2} value={"+595"}>
                            +595
                          </Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col sm={9} xs={20}>
                      <FormItem label="Telefone" name="phone">
                        <MaskedInput
                          disabled={!canEditFields()}
                          name="phone"
                          mask="(11) 11111-1111"
                          placeholder="(99) 99999-9999"
                        />
                      </FormItem>
                    </Col>
                  </Row>

                  <>
                    <Divider orientation="left">
                      Dados de localização do usuário
                    </Divider>
                    {selectCountryInput === "BR" ? (
                      <>
                        <Row gutter={12}>
                          <Col sm={12} xs={24}>
                            <FormItem label="CEP" name="cep">
                              <MaskedInput
                                disabled={!canEditFields()}
                                name="cep"
                                mask="11111-111"
                                onChange={(value) => handleChangeCep(value)}
                                placeholder="00000-000"
                              />
                            </FormItem>
                          </Col>
                          <Col sm={12} xs={24}>
                            <Form.Item label="Endereço" name="address">
                              <Input
                                disabled={
                                  !!viaCepData?.logradouro || !canEditFields()
                                }
                                name="address"
                                placeholder="Preencha com o endereço"
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={12}>
                          <Col sm={12} xs={24}>
                            <Form.Item label="Estado" name="state">
                              <Input
                                disabled={!!viaCepData || !canEditFields()}
                                name="state"
                                placeholder="Preencha com o Estado"
                              />
                            </Form.Item>
                          </Col>
                          <Col sm={12} xs={24}>
                            <Form.Item label="Cidade" name="city">
                              <Input
                                disabled={!!viaCepData || !canEditFields()}
                                name="city"
                                placeholder="Preencha com a cidade"
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={12}>
                          <Col sm={12} xs={24}>
                            <Form.Item label="Bairro" name="district">
                              <Input
                                disabled={
                                  !!viaCepData?.bairro || !canEditFields()
                                }
                                name="district"
                                placeholder="Preencha com o bairro"
                              />
                            </Form.Item>
                          </Col>
                          <Col sm={12} xs={24}>
                            <Form.Item label="Complemento" name="complement">
                              <Input
                                disabled={!!viaCepData || !canEditFields()}
                                name="complement"
                                placeholder="Preencha com o complemento"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row gutter={12}>
                          <Col sm={12} xs={24}>
                            <Form.Item label="CEP" name="cep">
                              <MaskedInput
                                placeholder="CEP"
                                mask="111111"
                                name="cep"
                                disabled={!canEditFields()}
                              />
                            </Form.Item>
                          </Col>

                          <Col sm={12} xs={24}>
                            <Form.Item label="Departamento" name="distrito_py">
                              <Select
                                placeholder="Departamento"
                                showSearch
                                disabled={!canEditFields()}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option?.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {paraguaiDistrict.map((state) => (
                                  <Select.Option value={state} key={state}>
                                    {state}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col sm={12} xs={24}>
                            <Form.Item label="Cidade" name="city">
                              <Input
                                disabled={!canEditFields()}
                                type="text"
                                name="city"
                                placeholder="Cidade"
                                maxLength={70}
                              />
                            </Form.Item>
                          </Col>

                          <Col sm={12} xs={24}>
                            <Form.Item label="Endereço" name="address">
                              <Input
                                disabled={!canEditFields()}
                                type="text"
                                name="address"
                                placeholder="Endereço"
                                maxLength={100}
                              />
                            </Form.Item>
                          </Col>

                          <Col sm={12} xs={24}>
                            <Form.Item label="Bairro" name="district">
                              <Input
                                disabled={!canEditFields()}
                                type="text"
                                name="district"
                                placeholder="Bairro"
                              />
                            </Form.Item>
                          </Col>

                          <Col sm={12} xs={24}>
                            <Form.Item
                              label="Complemento"
                              name="complement"
                              rules={[
                                {
                                  required: false,
                                  message: "Complemento é obrigatório",
                                },
                              ]}
                            >
                              <Input
                                disabled={!canEditFields()}
                                type="text"
                                name="complement"
                                placeholder="Complemento"
                                maxLength={30}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                </Tabs.TabPane>
              )}
            </Tabs>
          </Form>
        ) : (
          <VerificationPhone
            userId={user?.id as number}
            phoneNumber={
              pendingUserData?.phone
                ? pendingUserData.phone
                : onlyNumbers(form.getFieldValue("phone") || "")?.toString()
            }
            onVerified={completeUpdate}
            onCancel={() => {
              setCurrentStep(0);
              setPendingUserData(null);
            }}
            title="Verificação de Número de Telefone"
            showCancelConfirmation={true}
          />
        )}
      </DrawerNewUser>

      <ModalConfirmEdit
        title={
          <>
            <Exclamation></Exclamation>
            <span>Atenção</span>
          </>
        }
        destroyOnClose={true}
        centered
        confirmLoading={loading}
        visible={visibleConfirmEdit}
        closable={false}
        footer={
          <BtnsModalUser>
            <ButtonCancel
              onClick={() => {
                setVisibleConfirmEdit(false);
              }}
            >
              Cancelar
            </ButtonCancel>
            <ButtonSave
              type="primary"
              htmlType="submit"
              loading={loading}
              onClick={() => {
                onFinish();
              }}
            >
              Confirmar
            </ButtonSave>
          </BtnsModalUser>
        }
      >
        <Exclamation />
        <span>Você tem certeza que deseja alterar os dados desse usuário?</span>
      </ModalConfirmEdit>
    </>
  );
};

export default UserForm;
